import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdId = "/decisioning_studio_agents/:app_group_id/:id";

export const decisioningStudioAgentsAppGroupIdIdCacheKeys: AllRouteEndpoints[] = [
  "/decisioning_studio_agents/:app_group_id/:id",
];
